export default {"src":"/_next/static/media/skeleton-logo.d908e590.svg","height":75,"width":61,"blurWidth":0,"blurHeight":0};